import { createSlice } from "@reduxjs/toolkit"
import { createAsyncThunk } from '@reduxjs/toolkit';
import { config } from "services/globalvariables/globalvariables";
import { RootState } from '../store';
import axios from 'axios'
import { notifyAddTocart } from "components/userprofile/components/MyProfile";
//
//
export interface authSliceState {
    isLoggedIn: Boolean,
    profile: [],
    loading: Boolean,
    error: string,
    status: string | number | undefined;
}

const initialState: authSliceState = {
    isLoggedIn: false,
    profile: [],
    loading: false,
    error: '',
    status: undefined
}
//
//

// -------------------------------------------------------------------
// --------Fetch User Profile After OTP verified ---------------------
// -------------------------------------------------------------------
export const getProfile: any = createAsyncThunk(
    'user/getProfile',
    async ({ number, otp, onCloseModalQuickView }: any) => {
        try {
            const RESULT = await axios.post(
                `${process.env.REACT_APP_HOST}partner/v1/otp-verify/`,
                {
                    number: number,
                    otp: otp,
                },
                config
            );
            if (onCloseModalQuickView) onCloseModalQuickView();
            return RESULT.data
        } catch (err: any) {
            if (err) {
                console.log(err)
                throw Error(err.response.data.message)
            }
            return { err }
        }
    }
)

//
//
export const updateProfile: any = createAsyncThunk(
    'user/updateprofile',
    async ({ profile_img, uid, full_name, mobile_number, email, address }: any) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_HOST}partner/v1/update_profile/owner/`,
                {
                    profile_img,
                    uid,
                    full_name,
                    mobile_number,
                    email,
                    address
                },
                config
            );
            //
            notifyAddTocart(response.data.message)
            //
            return response.data
        } catch (err: any) {
            if (err.response.data.status === 240) {
                console.log(err)
                throw Error('something went wrong')
            }
            return err.message
        }
    }
)
//
//

export const logoutThunk = createAsyncThunk<void, any, { state: RootState }>(
    'auth/logout',
    async (history, { dispatch }) => {
        dispatch(logout());
        history.push('/');
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout(state) {
            state.isLoggedIn = false;
            state.profile = [];
        },

    },
    extraReducers: (builder) => {
        //
        builder
            .addCase(getProfile.pending, (state) => {
                state.loading = true;
                state.error = ''; // 
            })
            .addCase(getProfile.fulfilled, (state, action) => {
                const { status, message } = action.payload
                state.loading = false;
                //
                if (status === 240) {
                    state.profile = [];
                    state.isLoggedIn = false;
                    state.error = message
                    return
                }
                state.profile = action.payload
                state.isLoggedIn = true
            })
            .addCase(getProfile.rejected, (state, action) => {
                state.loading = false;
                state.isLoggedIn = false;
                state.profile = []
                state.error = action.error.message
            });
        //
        //
        //
        //
        builder
            .addCase(updateProfile.pending, (state) => {
                state.loading = true;
                state.error = ''; // 
            })
            .addCase(updateProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.profile = action.payload
            })
            .addCase(updateProfile.rejected, (state, action) => {
                state.error = action.error.message
            });

    }

})
export default authSlice.reducer

export const { logout } = authSlice.actions;